import { Alert, AlertTitle, List, ListItem, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetSupportCase } from '../../hooks';
import { FullName } from '../full-name/full-name.component';

interface Props {
    supportCaseId?: string;
}

export const IntakeIntroWarning: FC<Props> = ({ supportCaseId }) => {
    const { t } = useTranslation();
    const { data: supportCase } = useGetSupportCase(supportCaseId as string);

    const invalidData = supportCase?.supportees
        ?.filter((supportee) => !supportee.nationalSecurityNumber || !supportee.gender || !supportee.dateOfBirth)
        .map((supportee) => {
            const invalidNSN = !supportee.nationalSecurityNumber ? `${t('nationalSecurityNumberLabel')}` : undefined;
            const invalidGender = !supportee.gender ? `${t('genderLabel')}` : undefined;
            const invalidDateOfBirth = !supportee.dateOfBirth ? `${t('dateOfBirthLabel')}` : undefined;

            return {
                supportee: supportee,
                invalid: [invalidNSN, invalidGender, invalidDateOfBirth].filter(Boolean).join(', '),
            };
        });

    if (invalidData && invalidData.length > 0) {
        return (
            <Alert severity="warning">
                <AlertTitle>{t('intakeWarningTitle')}</AlertTitle>
                <Stack spacing={1}>
                    <Typography variant="body2">{t('intakeWarningPart1')}</Typography>
                    <List sx={{ listStyleType: 'disc', pl: 2 }}>
                        {invalidData.map((data) => (
                            <ListItem sx={{ display: 'list-item' }} key={data.supportee.id}>
                                <Typography variant="body2">
                                    <FullName data={data.supportee} /> {`(${data.invalid})`}
                                </Typography>
                            </ListItem>
                        ))}
                    </List>
                    <Typography variant="body2">{t('intakeWarningPart2')}</Typography>
                </Stack>
            </Alert>
        );
    }
};
